function addLinkToContent() {
  document.addEventListener('DOMContentLoaded', () => {
    const cookieContent = document.querySelector('#CybotCookiebotDialogBodyContentText')
    if (cookieContent) {
      const privacyText = '#insertprivacyhere#'
      const privacyLink = '<a href="/privacy-policy">Privacy Policy</a>'
      const preString = cookieContent.innerHTML.toString()
      let replaced = preString.replace(privacyText, privacyLink)
      cookieContent.innerHTML = replaced
    }
  })
}
addLinkToContent()

function cookieBotStyling() {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      const mainCookie = document.querySelector('#CybotCookiebotDialog')
      if (mainCookie) {
        const mainCookieBanner = document.querySelector('#CybotCookiebotDialogBody')
        mainCookie.classList.add('show-cookie')
        // show details
        const cookieShowDetailButton = document.querySelector('#CybotCookiebotDialogBodyContentText #cookieManage')
        const cookieDetail = document.querySelector('#CybotCookiebotDialogDetail')
        if (cookieShowDetailButton) {
          cookieShowDetailButton.addEventListener('click', (e) => {
            e.preventDefault()
            cookieDetail.style.display = 'flex'
            mainCookieBanner.classList.add('d-none')
          })
        } else {
          document.querySelectorAll('#CybotCookiebotDialogBodyContentText a')[0].addEventListener('click', (e) => {
            e.preventDefault()
            cookieDetail.style.display = 'flex'
            mainCookieBanner.classList.add('d-none')
          })
        }
        // add buttons to detail
        const cookieButtonBar = document.querySelector('#CybotCookiebotDialogBodyLevelButtons')
        const cookieClose = document.createElement('div')
        cookieClose.classList.add('cookie-dialog-close')
        const cookieDialogPopup = cookieDetail.querySelector('#CybotCookiebotDialogDetailBodyContentCookieContainer')
        cookieDialogPopup.appendChild(cookieButtonBar)
        cookieDialogPopup.prepend(cookieClose)

        cookieClose.addEventListener('click', () => {
          detailMain.style.display = 'none'
          mainCookieBanner.classList.remove('d-none')
        })
        // add content after tabs
        const tabContents = document.querySelectorAll('#CybotCookiebotDialogDetailBodyContentCookieContainerTypeDetails >div')
        const tabBoxes = document.querySelectorAll('#CybotCookiebotDialogDetailBodyContentCookieContainerTypes a')
        const checkBoxes = document.querySelectorAll('#CybotCookiebotDialogBodyLevelButtonsSelectPane .CybotCookiebotDialogBodyLevelButtonWrapper')
        if (tabBoxes) {
          Array.prototype.forEach.call(tabBoxes, (box, index) => {
            box.setAttribute('href', '#/')
            box.appendChild(tabContents[index])
            if (checkBoxes[index]) {
              insertAfter(checkBoxes[index], box)
            }
            // accordion toggle
            box.setAttribute('data-opened', 'closed')
            box.addEventListener('click', (e) => {
              
              e.preventDefault()
              if (e.target !== box.querySelector('.CybotCookiebotDialogBodyLevelButtonWrapper label')) {
                if (box.getAttribute('data-opened') === 'closed') {
                  Array.prototype.forEach.call(tabBoxes, (boxy) => {
                    boxy.setAttribute('data-opened', 'closed')
                  })
                  box.setAttribute('data-opened', 'opened')
                } else {
                  box.setAttribute('data-opened', 'closed')
                }
              }
            })
          })
        }

        // hide detail 

        const detailMain = document.querySelector('#CybotCookiebotDialogDetail')
        detailMain.addEventListener('click', (e) => {
          if (e.target === detailMain && detailMain.style.display === 'flex') {
            detailMain.style.display = 'none'
            mainCookieBanner.classList.remove('d-none')
          }
        })

        // add banner text to dialog
        const textContent = document.querySelector('#CybotCookiebotDialogBodyContentText').innerHTML
        const dialogContainer = document.querySelector('#CybotCookiebotDialogDetailBodyContentCookieContainer')
        const newTextNode = document.createElement('div')
        const newTitleNode = document.createElement('h3')
        newTitleNode.innerHTML = 'Cookie Settings'
        newTextNode.classList.add('detail-content-wrapper')
        newTextNode.innerHTML = textContent
        dialogContainer.prepend(newTextNode)
        dialogContainer.prepend(newTitleNode)

        // allow all button to dialog

        const allowButton = document.querySelector('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection');
        cookieDialogPopup.appendChild(allowButton)

      }

      const dialogPopupLinkWrapper = document.querySelector('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper')
      createLink('Privacy Policy', '/privacy-policy', dialogPopupLinkWrapper)
      createLink('GTA', '/gta', dialogPopupLinkWrapper)
    }, 3000)
  })
}

cookieBotStyling()

function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function createLink(inner, link, append) {
  let elem = document.createElement('a')
  if (elem) {
    elem.innerHTML = inner
    elem.classList.add('CybotCookiebotDialogBodyButton')
    elem.style.marginLeft = 0
    elem.setAttribute('href', link)
    if (append) {
      append.prepend(elem)
    }
  }
}
// createLink('Privacy Policy', '/privacy-policy', cookieDialogPopup)
// createLink('GTA', '/gta', cookieDialogPopup)